import { object, string, date, number } from 'yup';

export const placeholderStockingValidation = (maxQuantity: number) =>
  object().shape({
    lot: string().required('Lot is required'),
    expiration: date().required('Expiration is required'),
    zoneId: string().required('Zone is required'),
    quantity: number()
      .required('Quantity is required')
      .min(1, 'Quantity must be at least 1')
      .max(maxQuantity, `Cannot exceed remaining quantity (${maxQuantity})`),
  });
